import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DigitaalondertekenbeheerResource {
    httpClient = inject(HttpClient);

    private readonly baseUrl = '/services/apic-digitaalondertekenbeheer/api';

    public getDocumentAsPdf(documentId: string) {
        return this.httpClient.get(`${this.baseUrl}/documenten/${documentId}`, {
            headers: { accept: 'application/pdf' },
            responseType: 'blob'
        });
    }
}
